(function (window) {
    function notify(type, text, duration, opts) {
        if (!window.Noty) {
            window.alert(`${type}: ${text}`);
            return;
        }

        const n = new Noty(Object.assign({
            type: type,
            text: text,
            timeout: duration || 5000,
            progressBar: true,
            closeWith: ['click'],
            layout: 'topRight',
            theme: 'mint'
        }, (opts || {})));
        n.show();
        return n;
    }

    const success   = (text, duration, opts) => { notify('success', text, duration, opts); }
    const error     = (text, duration, opts) => { notify('error', text, duration, opts); }
    const warning   = (text, duration, opts) => { notify('warning', text, duration, opts); }
    const info      = (text, duration, opts) => { notify('info', text, duration, opts); }

    const extractErrors = (payload) => {
        if (!payload) return ["Something went wrong"];
        if (Array.isArray(payload.errors)) return payload.errors;
        if (typeof payload.errors === 'string') return [payload.errors];

        if (payload.errors && typeof payload.errors === 'object') {
            const out = [];
            Object.keys(payload.errors).forEach(key => {
                const v = payload.errors[key];
                if (Array.isArray(v)) out.push(...v);
                else if (typeof v === 'string') out.push(v);
            });
            return out.length ? out : ["Something went wrong"];
        }

        return ["Something went wrong"];
    }

    window.WorkplaceNoty = { notify, success, error, warning, info, extractErrors };

})(window);
(function (window) {
    function notify(type, text, duration, opts) {
        if (!window.Noty) {
            window.alert(`${type}: ${text}`);
            return;
        }

        const n = new Noty(Object.assign({
            type: type,
            text: text,
            timeout: duration || 5000,
            progressBar: true,
            closeWith: ['click'],
            layout: 'topRight',
            theme: 'mint'
        }, (opts || {})));
        n.show();
        return n;
    }

    const success   = (text, duration, opts) => { notify('success', text, duration, opts); }
    const error     = (text, duration, opts) => { notify('error', text, duration, opts); }
    const warning   = (text, duration, opts) => { notify('warning', text, duration, opts); }
    const info      = (text, duration, opts) => { notify('info', text, duration, opts); }

    const extractErrors = (payload) => {
        if (!payload) return ["Something went wrong"];
        if (Array.isArray(payload.errors)) return payload.errors;
        if (typeof payload.errors === 'string') return [payload.errors];

        if (payload.errors && typeof payload.errors === 'object') {
            const out = [];
            Object.keys(payload.errors).forEach(key => {
                const v = payload.errors[key];
                if (Array.isArray(v)) out.push(...v);
                else if (typeof v === 'string') out.push(v);
            });
            return out.length ? out : ["Something went wrong"];
        }

        return ["Something went wrong"];
    }

    window.WorkplaceNoty = { notify, success, error, warning, info, extractErrors };

})(window);
